import * as React from 'react';

/**
 * Martini-glass icon for the "Bar" amenity. Authored here because the Figma
 * design reuses the Shower glyph for the Bar row (a copy-paste slip), which
 * would render a shower head next to "Bar".
 */
export default function Bar({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 20 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 3.75 H16.5 L10.75 9.75 V15.25 H13.25 A0.75 0.75 0 0 1 13.25 16.75 H6.75 A0.75 0.75 0 0 1 6.75 15.25 H9.25 V9.75 L3.5 3.75 Z M6.62 5.25 L10 8.78 L13.38 5.25 Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
